import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import cs from 'classnames';
import { useIsInboundVersion } from '../../hooks/useIsInboundVersion';
import { useStudioSignupUrl } from '../../hooks/useStudioSignupUrl';
import { footerDataHooks as dataHooks } from './Footer.dataHooks';
import s from './Footer.scss';
import { useEditUrl } from '../../hooks/useNewEditUrl';
import { BLANK_TEMPLATE_META_SITE_ID } from '../../config';
import { useBiLogger } from '../../contexts/BILoggerContext';
import { useExperiments } from '../../contexts/ExperimentsContext';

export const Footer = () => {
  const { t } = useTranslation();
  const isInboundVer = useIsInboundVersion();
  const studioSignupUrl = useStudioSignupUrl();
  const biLogger = useBiLogger();
  const experiments = useExperiments();

  const showMarketplaceFooter = experiments.is(
    'specs.funnel.StudioTemplatesNewMarketplaceFooter',
    'true',
  );

  const marketplaceUrl =
    'https://www.wix.com/marketplace/templates?entry=templates-page&origin=templates-marketplace-banner';

  const blankTemplateEditUrl = useEditUrl({
    metaSiteId: BLANK_TEMPLATE_META_SITE_ID,
  });

  const onLinkClick = () => {
    const action =
      (showMarketplaceFooter && 'explore_marketplace') ||
      (isInboundVer && 'start_from_blank') ||
      'start_creating';
    const action_value = isInboundVer ? undefined : 'start_creating_footer';

    biLogger.reportGeneralAction({ action, actionValue: action_value });
  };

  const inboundUrl = showMarketplaceFooter
    ? marketplaceUrl
    : blankTemplateEditUrl;

  return (
    <div className={s.container}>
      <div
        className={cs(s.description, {
          [s.descriptionOutbound]: !isInboundVer,
        })}
      >
        <div className={s.descriptionText} data-hook={dataHooks.description()}>
          {(showMarketplaceFooter &&
            t('app.new.footer.description.marketplace')) ||
            (isInboundVer && t('app.new.footer.description.inbound')) ||
            t('app.new.footer.description.outbound')}
        </div>
      </div>
      <a
        href={
          showMarketplaceFooter
            ? marketplaceUrl
            : isInboundVer
            ? inboundUrl
            : studioSignupUrl
        }
        className={s.wrapperLink}
        data-hook={dataHooks.link()}
        onClick={onLinkClick}
      >
        <div
          className={cs(s.buttonLabel, {
            [s.buttonLabelInbound]: isInboundVer,
          })}
          data-hook={dataHooks.linkLabel()}
        >
          {showMarketplaceFooter
            ? t('app.new.footer.buttonLabel.marketplace')
            : isInboundVer
            ? t('app.new.footer.buttonLabel.inbound')
            : t('app.new.footer.buttonLabel.outbound')}
        </div>
        <div className={s.button} />
      </a>
    </div>
  );
};
